<mat-card class="cardWithShadow">
  <mat-card-content class="p-24 table-responsive">

    <div style="text-align: center;" *ngIf="deptors.length == 0">
      <h3>Sin Deudores</h3>
    </div>

    <div class="flex" (click)="filterTop()" [ngClass]="{ active: top }">
    </div>

    <div [ngClass]="{ 'oculto': deptors.length == 0 }">
      <table
        mat-table
        [dataSource]="dataSource"
        class="w-100"
        matSort
        matSortDirection="asc"
        style="cursor: pointer;"
      >
        <!-- Position Column -->
        <ng-container matColumnDef="name">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Nombre
          </th>
          <td mat-cell *matCellDef="let element">
            <h6>
              {{ element.name }}
            </h6>
          </td>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="rut">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="th-title"
          >
            Rut
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>
              {{ element.rut }}
            </h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="sellTotalAmount">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="th-title"
          >
            Monto Total de Ventas
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>
              {{ element.sellTotalAmount | currency:'CLP':'symbol' }}
            </h6>
          </td>
        </ng-container>

        <!-- Symbol Column -->
        <ng-container matColumnDef="sellInvoices">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="th-title"
          >
            Facturas
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.sellInvoices }}</h6>
          </td>
        </ng-container>
        <ng-container matColumnDef="transferTotalAmount">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="th-title"
          >
            Monto Total Cedido
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.transferTotalAmount | currency:'CLP':'symbol' }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="transferInvoices">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Facturas Cedidas
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.transferInvoices }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="dueApprovingStatus">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Vigencia de Resolución
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.dueApprovingStatus | date: 'dd-MM-yyyy' }}</h6>
          </td>
        </ng-container>

        <ng-container matColumnDef="clientApprovingStatus">
          <th
            mat-header-cell
            mat-sort-header
            *matHeaderCellDef
            class="th-title"
          >
            Resolución
          </th>
          <td mat-cell *matCellDef="let element" class="mat-body-1">
            <h6>{{ element.clientApprovingStatus }}</h6>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row class="cursor-table" *matRowDef="let row; columns: displayedColumns"
          [cdkContextMenuTriggerFor]="menu"
        >
          <ng-template #menu>
            <div
              cdkMenu
              class="context_menu mat-elevation-z8"
              style="display: flex; flex-direction: column"
            >
            <button
            class="context-menu-item"
            cdkMenuItem
            mat-raised-button
            style="background-color: #198754; color: white"
            (click)="abrirModalDicom(row.rut)"
          >
            Consultar Dicom
          </button>
          <button
            class="context-menu-item"
            cdkMenuItem
            mat-raised-button
            (click)="viewDebtorRelationship(row.companyId)">
            Ver resumen
          </button>
              <!--<button
                class="context-menu-item"
                cdkMenuItem
                mat-raised-button
                style="background-color: #3f51b5; color: white"
              >
                Aprobar
              </button>-->
            </div>
          </ng-template>
        </tr>

        <!-- Row shown when there is no matching data. -->
        <!-- <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" colspan="4">
                No data matching the filter "{{ input.value }}"
              </td>
            </tr> -->
      </table>
      <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
